export default __webpack_public_path__ + "static/media/x-twitter.632308b8.png";